import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Route as RouteIcon, Save, ArrowLeft } from "lucide-react";
import RouteFields from "@/components/RouteFields";

const DEFAULT = {
  name: "",
  departure: "",
  arrival: "",
  legs: [
    { name: "Point 1", altitude: 2000, trackTrue: 90, distance: 20, variation: 0, alternate: "" },
  ],
};

export default function RouteForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(DEFAULT);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id) api.get(`/routes/${id}`).then((r) => setForm({ ...DEFAULT, ...r.data }));
  }, [id]);

  const save = async () => {
    if (!form.name) return toast.error("Nom de route requis");
    setSaving(true);
    try {
      if (id) await api.put(`/routes/${id}`, form);
      else await api.post("/routes", form);
      toast.success("Route enregistrée");
      navigate("/routes");
    } catch {
      toast.error("Erreur d'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <button onClick={() => navigate("/routes")} className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-300">
          <ArrowLeft className="h-4 w-4" /> Retour
        </button>
        <Button data-testid="save-route-button" onClick={save} disabled={saving}
          className="bg-cyan-500 font-semibold text-[#070C18] hover:bg-cyan-400">
          <Save className="mr-1.5 h-4 w-4" /> Enregistrer
        </Button>
      </div>

      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-cyan-500/80">
        <RouteIcon className="h-3.5 w-3.5" /> {id ? "Modifier la route" : "Nouvelle route"}
      </div>

      <RouteFields form={form} setForm={setForm} />
    </div>
  );
}
